var _rect, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogoPaypal(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    rx: 8,
    fill: "#E8F9FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31 34H16V14H31V34Z",
    stroke: "#E5E7EB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.3518 25.5586C20.215 26.3086 19.6721 29.8047 19.5119 30.793C19.5002 30.8633 19.4729 30.8906 19.3947 30.8906H16.4807C16.1838 30.8906 15.9689 30.6328 16.008 30.3477L18.2971 15.8203C18.3557 15.4453 18.6916 15.1602 19.0783 15.1602C25.0275 15.1602 25.5275 15.0156 27.0471 15.6055C29.3947 16.5156 29.6096 18.7109 28.7658 21.0859C27.926 23.5313 25.9338 24.582 23.2932 24.6133C21.5978 24.6406 20.5783 24.3399 20.3518 25.5586ZM29.9494 19.9375C29.8791 19.8867 29.8518 19.8672 29.8322 19.9883C29.7541 20.4336 29.633 20.8672 29.4885 21.3008C27.9299 25.7461 23.6096 25.3594 21.5002 25.3594C21.2619 25.3594 21.1057 25.4883 21.0744 25.7266C20.1916 31.2109 20.0158 32.3555 20.0158 32.3555C19.9768 32.6328 20.1525 32.8594 20.4299 32.8594H22.9103C23.2463 32.8594 23.5236 32.6133 23.59 32.2774C23.6174 32.0664 23.5471 32.5156 24.1525 28.7109C24.3322 27.8516 24.7111 27.9414 25.2971 27.9414C28.0705 27.9414 30.2346 26.8164 30.8791 23.5547C31.133 22.1953 31.0588 20.7656 29.9494 19.9375Z",
    fill: "#179BD7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoPaypal);
export default __webpack_public_path__ + "static/media/logo-paypal.52260100006177349867cc8eb1864c0a.svg";
export { ForwardRef as ReactComponent };